import styled from 'styled-components';

export const Icon = ({
	$svg,
	$url,
	alt,
	$width = 24,
	$height = 24,
	$title = '',
	$active = false
}: IconProps): JSX.Element => {
	return (
		<>
			{$svg ? (
				<SVGWrapper $width={$width} $height={$height} $active={$active}>
					{$svg}
				</SVGWrapper>
			) : (
				<img
					src={$url}
					alt={alt}
					width={$width}
					height={$height}
					title={$title}
					style={{ fill: $active ? '#f47920' : '#222222' }}
				/>
			)}
		</>
	);
};

const SVGWrapper = styled.div<IconProps>`
	padding: 0;
	margin: 0;
	height: ${props => (props.$height ? `${props.$height}px` : '24px')};
	width: ${props => (props.$width ? `${props.$width}px` : '24px')};

	svg,
	path {
		height: ${props => (props.$height ? `${props.$height}px` : '24px')};
		width: ${props => (props.$width ? `${props.$width}px` : '24px')};
		fill: ${props => (props.$active ? '#f47920' : '#222222')};
	}
`;

export interface IconProps {
	$svg?: JSX.Element;
	$url?: any;
	alt?: string;
	$width?: number;
	$height?: number;
	$title?: string;
	$active?: boolean;
}

export default Icon;
